import { render, staticRenderFns } from "./AccountPurposesComponent.vue?vue&type=template&id=77118119&"
import script from "./AccountPurposesComponent.vue?vue&type=script&lang=js&"
export * from "./AccountPurposesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports